<div fxLayout="row"
  fxLayoutAlign="start ">
  <div fxFlex="1 0 auto">
    <h1>Edit your profile</h1>
  </div>
  <div fxFlex="0 0 auto"
    fxFlexAlign="center"
    class="actions">
    <button mat-flat-button
      color="primary"
      (click)="submit()">Save Profile</button>
  </div>
</div>
<form [formGroup]="userForm">
  <div fxLayout="row"
    fxLayoutGap="50px">
    <div fxFlex="0 0 auto">
      <h2>Profile Image</h2>
      <ca-photo-picker formControlName="profileImage"
        title="Proile Image"></ca-photo-picker>
    </div>
    <div fxFlex="1 1 auto">
      <h2>Profile</h2>
      <mat-form-field>
        <input matInput
          formControlName="firstName"
          placeholder="First Name">
        <mat-error *ngIf="firstNameControl.hasError('required')">
          First name is required
        </mat-error>
      </mat-form-field>
      <mat-form-field>
        <input matInput
          formControlName="lastName"
          placeholder="Last Name">
        <mat-error *ngIf="lastNameControl.hasError('required')">
          Last name is required
        </mat-error>
      </mat-form-field>
      <button mat-stroked-button
        color="warn"
        *ngIf="!changePassword"
        (click)="changePassword = true">Change Password</button>
      <mat-form-field *ngIf="changePassword">
        <input matInput
          type="password"
          formControlName="password"
          placeholder="Change Password">
        <mat-error *ngIf="passwordControl.hasError('required')">
          Password is required
        </mat-error>
        <mat-error *ngIf="passwordControl.hasError('minlength')">
          Password must be at least 5 characters long
        </mat-error>
      </mat-form-field>
    </div>
  </div>
</form>